import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import ContactModal from './ContactModal';
import DownloadModal from './DownloadModal';
import DisclaimerModal from './DisclaimerModal';
import LoginModal from './LoginModal';
import DemoVideoModal from './DemoVideoModal';
import { useAuth } from '../../../context/AuthContext';
import { toast } from 'react-hot-toast';
import { resolveDownloadUrl, triggerBrowserDownload } from '../../../utils/downloadResume';

export default function WebsiteLayout() {
  const navigate = useNavigate();
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [isDownloadOpen, setIsDownloadOpen] = useState(false);
  const [isDisclaimerOpen, setIsDisclaimerOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isDemoOpen, setIsDemoOpen] = useState(false);
  const [contactSubject, setContactSubject] = useState('');
  const [contactMessage, setContactMessage] = useState('');
  const { isAuthenticated } = useAuth();

  const handleOpenContact = (subject = '', message = '') => {
    setContactSubject(subject || '');
    setContactMessage(message || '');
    setIsContactOpen(true);
  };

  const handleOpenDownloadModal = (explicitUrl = null) => {
    if (explicitUrl && typeof explicitUrl === 'string') {
      try {
        sessionStorage.setItem('candor_pending_download', JSON.stringify({ url: explicitUrl }));
      } catch { /* noop */ }
    }
    setIsDownloadOpen(true);
  };

  const handleDownloadClick = async (explicitUrl = null) => {
    if (explicitUrl && typeof explicitUrl === 'string') {
      if (isAuthenticated) {
        try {
          const downloadLink = await resolveDownloadUrl(explicitUrl);
          triggerBrowserDownload(downloadLink);
          toast.success('Your Candor IDE download has started!');
        } catch (err) {
          console.error('Download failed:', err);
        }
      } else {
        handleOpenDownloadModal(explicitUrl);
      }
    } else {
      // General download request: navigate to dedicated multi-platform Download page
      navigate('/download');
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-white text-slate-800 font-sans">
      <Navbar
        onOpenContact={handleOpenContact}
        onOpenDownload={handleDownloadClick}
        onOpenLogin={() => setIsLoginOpen(true)}
      />

      <main className="pt-16 flex-grow flex flex-col">
        <Outlet
          context={{
            onOpenContact: handleOpenContact,
            onOpenDownload: handleDownloadClick,
            onOpenDownloadModal: handleOpenDownloadModal,
            onOpenLogin: () => setIsLoginOpen(true),
            onOpenDemo: () => setIsDemoOpen(true),
          }}
        />
      </main>

      <Footer
        onOpenDisclaimer={() => setIsDisclaimerOpen(true)}
      />

      <ContactModal
        isOpen={isContactOpen}
        onClose={() => {
          setIsContactOpen(false);
          setContactSubject('');
          setContactMessage('');
        }}
        defaultSubject={contactSubject}
        defaultMessage={contactMessage}
      />

      <DownloadModal
        isOpen={isDownloadOpen}
        onClose={() => setIsDownloadOpen(false)}
      />

      <DisclaimerModal
        isOpen={isDisclaimerOpen}
        onClose={() => setIsDisclaimerOpen(false)}
      />

      <LoginModal
        isOpen={isLoginOpen}
        onClose={() => setIsLoginOpen(false)}
      />

      <DemoVideoModal
        isOpen={isDemoOpen}
        onClose={() => setIsDemoOpen(false)}
        onOpenDownload={handleDownloadClick}
      />
    </div>
  );
}
